import React, { Component } from 'react';

import Header from "../Header/Header"
import Welcome from '../Welcome/Welcome';
import ManotFalafel from '../ManotFalafel/ManotFalafel';
import ManotSelected from '../ManotSelected/ManotSelected';
import Popup from '../Popup/Popup';

class App extends Component {
  constructor() {
    super();
    this.state = {
      current: 0,
      removeSelected: -1,
      chooseMeal: -1,
      mealsSelected: [{ "ID": 1 }],
      popupData: {
        data: {},
        isChoosen: ""
      },
      showLoader: false,
      isPoping: false
    }
    this.getMeal = this.getMeal.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.showLoader = this.showLoader.bind(this);
    this.triggerPopup = this.triggerPopup.bind(this);
    this.chooseMeal = this.chooseMeal.bind(this);
  }
  getMeal(_meal, count) {
    const _mealsSelected = this.state.mealsSelected;
    if (_mealsSelected.indexOf(_meal) < 1) {
      _mealsSelected.push(_meal);
    } else {
      _mealsSelected.splice(_mealsSelected.indexOf(_meal), 1);
    }
    this.setState({
      current: count,
      mealsSelected: (count == 0 ? [{ "ID": 1 }] : _mealsSelected)
    })
  }
  removeSelected(id) {
    this.setState({
      removeSelected: id
    })
    window.setTimeout(() => {
      this.setState({
        removeSelected: -1
      })
    }, 250)
  }
  showLoader() {
    this.setState({
      showLoader: !this.state.showLoader
    })
  }
  triggerPopup(data, isChoosen) {
    this.setState({
      isPoping: !this.state.isPoping,
    });
    if (data) {
      this.setState({
        popupData: {
          data,
          isChoosen: isChoosen
        }
      })
    }
  }
  chooseMeal(id) {
    this.setState({
      chooseMeal: id
    })
    window.setTimeout(() => {
      this.setState({
        chooseMeal: -1
      })
    }, 250)
  }
  render() {
    return (
      // ${(this.setState.isPoping ? " popupActive" : "")}
      <div className={`App`}>
        <Header />
        <Popup
          chooseMeal={this.chooseMeal}
          popupData={this.state.popupData}
          triggerPopup={this.triggerPopup}
          isPoping={this.state.isPoping}
          isLoading={this.state.showLoader}
          getMeal={this.getMeal}
          removeSelected={this.state.removeSelected}
          current={this.state.current} />
        <Welcome />
        <ManotFalafel
          triggerPopup={this.triggerPopup}
          showLoader={this.showLoader}
          isLoading={this.state.showLoader}
          chooseMeal={this.state.chooseMeal}
          getMeal={this.getMeal}
          removeSelected={this.state.removeSelected}
          current={this.state.current} />
        <ManotSelected
          triggerPopup={this.triggerPopup}
          showLoader={this.showLoader}
          getMeal={this.getMeal}
          mealsSelected={this.state.mealsSelected}
          removeSelected={this.removeSelected}
          current={this.state.current} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js